// @flow
import React from 'react';
import SearchFields from '../SearchFields/SearchFields';
import {compose} from 'redux';
import {connect} from 'react-redux';
import routerActions from '../../actions/router';
import {SVGIcon} from '@homeaway/react-svg';
import {CALENDAR__16, SEARCH__16, PERSON__16} from '@homeaway/svg-defs';

import './MobileSearchBar.less';

type DispatchProps = {
    search: typeof routerActions.search,
    locationSearch: typeof routerActions.locationSearch
};

type Props = DispatchProps;

const datesDescriptor = {
    messageId: 'checkInCheckOut',
    defaultText: 'Check-in – Checkout'
};

const MobileSearchBar = ({search, locationSearch}: Props) => (
    <div className="MobileSearchBar">
        <SearchFields
            onChange={search}
            onLocationChange={locationSearch}
            searchIcon={
                <SVGIcon
                    markup={SEARCH__16}
                    className="MobileSearchBar__icon"
                />
            }
            guestpickerConfig={{
                guestsIcon: (
                    <SVGIcon
                        markup={PERSON__16}
                        className="MobileSearchBar__icon"
                    />
                )
            }}
            datepickerConfig={{
                hasDatesDescriptor: datesDescriptor,
                noDatesDescriptor: datesDescriptor,
                calendarIcon: (
                    <SVGIcon
                        markup={CALENDAR__16}
                        className="MobileSearchBar__icon"
                    />
                )
            }}
        />
    </div>
);

const mapDispatchToProps = {
    search: routerActions.search,
    locationSearch: routerActions.locationSearch
};

export default compose(
    connect(
        null,
        mapDispatchToProps
    )
)(MobileSearchBar);
